import React, { forwardRef } from 'react'
import styled, { css } from 'styled-components'
import { MqDesktop } from 'streamr-ui/css/consts'
import Layout from '~shared/Layout'
import Figure from '~shared/Figure'
import Spacer from '~shared/Spacer'

export const titleCss = css`
    margin-bottom: 64px;

    @media ${MqDesktop} {
        margin-bottom: 72px;
    }
`

export const CaseStudySpacer = forwardRef(function CaseStudySpacer(props, ref) {
    return <Spacer {...props} head="64px,160px,192px" tail ref={ref} />
})

const CaseStudyLayout = styled(Layout)`
    color: #0c009a;

    ${Layout.Inner} {
        background-color: #ffffff;
        color: #323232;
        padding-bottom: 24px;
        padding-top: 64px;
    }

    ${Figure.Caption} {
        color: #525252;
        margin-top: 16px;
    }

    @media ${MqDesktop} {
        ${Layout.Inner} {
            padding-top: 72px;
        }
    }
`

export default CaseStudyLayout
